import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  privacyPolicy: {
    id: 'portal.views.privacyPolicy.label.title',
    defaultMessage: 'Privacy Policy',
    description: 'Privacy Policy page title',
  },
  privacyPolicyBackgroundAlt: {
    id: 'portal.views.privacyPolicy.bg.alt',
    defaultMessage: 'Privacy policy background',
    description: 'Privacy policy background image alt',
  },
  intro: {
    id: 'portal.views.privacyPolicy.section.intro',
    defaultMessage: 'Legatum Limited and its affiliates (together “we”, “us”, “our” or “Legatum”) '
      + 'are committed to respecting your privacy. This privacy policy explains how Legatum uses '
      + 'the personal and course data we collect from you when you use the Leading with Character website.',
    description: 'Privacy Policy intro text',
  },
  whatDataTitle: {
    id: 'portal.views.privacyPolicy.whatData.title',
    defaultMessage: 'What data do we collect?',
    description: 'What data do we collect section title',
  },
  whatDataDescription: {
    id: 'portal.views.privacyPolicy.whatData.description',
    defaultMessage: 'We may collect personal information from you as you use our website, '
      + 'complete the course, or when you contact or request information from us. '
      + 'The personal information that we process includes:',
    description: 'What data do we collect description',
  },
  basicInfo: {
    id: 'portal.views.privacyPolicy.field.basicInfo',
    defaultMessage: 'basic information, such as your name (including name, prefix or title), '
      + 'the company you work for, your job title or position;',
    description: 'Basic info',
  },
  contactInfo: {
    id: 'portal.views.privacyPolicy.field.contactInfo',
    defaultMessage: 'contact information, such as your email address and phone number;',
    description: 'Contact info',
  },
  financialInfo: {
    id: 'portal.views.privacyPolicy.field.financialInfo',
    defaultMessage: 'financial information, such as payment-related information;',
    description: 'Financial info',
  },
  technicalInfo: {
    id: 'portal.views.privacyPolicy.field.technicalInfo',
    defaultMessage: 'technical information, such as information from your visits '
      + 'to our website or applications, or in relation to materials and communications we send to you electronically;',
    description: 'Technical info',
  },
  courseResponses: {
    id: 'portal.views.privacyPolicy.field.courseResponses',
    defaultMessage: 'responses to select course questions, such as your goals and '
      + 'achievements within the course, ways to improve the course, and ratings '
      + 'at the start and conclusion of each module;',
    description: 'Course responses info',
  },
  otherInfo: {
    id: 'portal.views.privacyPolicy.field.otherInfo',
    defaultMessage: 'any other information relating to you which you may provide to us.',
    description: 'Other info',
  },
  howCollectTitle: {
    id: 'portal.views.privacyPolicy.howCollect.title',
    defaultMessage: 'How do we collect your data?',
    description: 'How do we collect your data section title',
  },
  howCollectDesc1: {
    id: 'portal.views.privacyPolicy.howCollect.howCollectDesc1',
    defaultMessage: 'The majority of the information we hold about you will have been provided '
      + 'directly by you. This means that we collect your personal information upon course registration, '
      + 'when you submit a contact form or interact with us directly, or when you submit responses to the '
      + 'course prompts, including discussion forums, rating scale questions, and open response assessments.',
    description: 'How do we collect your data desc 1',
  },
  howCollectDesc2: {
    id: 'portal.views.privacyPolicy.howCollect.howCollectDesc2',
    defaultMessage: 'In some cases, we may collect or receive information about you from other '
      + 'sources, including supplementing the information you have given us with data from elsewhere. E'
      + 'xamples include adding social, economic, financial, or demographic data to our visitor '
      + 'information and improving or correcting contact details using publicly available sources. '
      + 'Sources of data could include information gathered from a news article or online media '
      + '(including social media) and publicly available directories. We may also obtain information '
      + 'about people entirely new to us. Examples include (but are not limited to) if an existing '
      + 'contributor suggests we get in touch to see if you might be interested in becoming involved with us.',
    description: 'How do we collect your data desc 2',
  },
  dataUsageTitle: {
    id: 'portal.views.privacyPolicy.dataUsage.title',
    defaultMessage: 'How will we use your data?',
    description: 'How will we use your data section title',
  },
  dataUsageDescription: {
    id: 'portal.views.privacyPolicy.dataUsage.description',
    defaultMessage: 'We collect and process personal information about you in '
      + 'a number of ways, including through your use of our website and the Leading '
      + 'with Character course. We use that information to:',
    description: 'How will we use your data desc',
  },
  useProvideImproveSite: {
    id: 'portal.views.privacyPolicy.dataUsage.useProvideImproveSite',
    defaultMessage: 'provide and improve this website and the Leading with Character course, '
      + 'including auditing and monitoring its use;',
    description: 'Use: provide and improve site',
  },
  useProvideImproveServices: {
    id: 'portal.views.privacyPolicy.dataUsage.useProvideImproveServices',
    defaultMessage: 'provide and improve our services to you;',
    description: 'Use: provide and improve services',
  },
  useProvideInfo: {
    id: 'portal.views.privacyPolicy.dataUsage.useProvideInfo',
    defaultMessage: 'provide information requested by you;',
    description: 'Use: provide info',
  },
  useDevelopContent: {
    id: 'portal.views.privacyPolicy.dataUsage.useDevelopContent',
    defaultMessage: 'develop additional content and courses;',
    description: 'Use: develop content',
  },
  usePromote: {
    id: 'portal.views.privacyPolicy.dataUsage.usePromote',
    defaultMessage: 'promote our services and market the course, including sending updates, publications, and details of events and other offerings. Direct quotes from your responses may be used in these promotional materials, but all personally identifiable data will be redacted to protect your confidentiality;',
    description: 'Use: promote',
  },
  useManageRelationship: {
    id: 'portal.views.privacyPolicy.dataUsage.useManageRelationship',
    defaultMessage: 'manage and administer our relationship with you (including administering correspondence with you);',
    description: 'Use: manage relationship',
  },
  useResearchPartners: {
    id: 'portal.views.privacyPolicy.dataUsage.useResearchPartners',
    defaultMessage: 'provide anonymized responses to our research partners, such '
      + 'as the Oxford Character Project at the University of Oxford and the Human Flourishing Program '
      + 'at Harvard University, to process and analyze the impact of the Leading with Character online course.',
    description: 'Use: research partners',
  },
  whereProcessTitle: {
    id: 'portal.views.privacyPolicy.whereProcess.title',
    defaultMessage: 'Where will we process your data?',
    description: 'Where will we process your data section title',
  },
  whereProcessDescription: {
    id: 'portal.views.privacyPolicy.whereProcess.description',
    defaultMessage: 'We process your data at our head offices and in any other places '
      + 'where the parties involved in the processing are located. Depending on your location, '
      + 'data transfers may involve transferring your data to a country other than your own. '
      + 'You are also entitled to learn about the legal basis of data transfers to a '
      + 'jurisdiction outside the Dubai International Financial Centre and about the security '
      + 'measures taken by us to safeguard your data.',
    description: 'Where will we process your data desc',
  },
  protectingTitle: {
    id: 'portal.views.privacyPolicy.protecting.title',
    defaultMessage: 'Protecting your data',
    description: 'Protecting your data section title',
  },
  protectingDescription: {
    id: 'portal.views.privacyPolicy.protecting.description',
    defaultMessage: 'We keep your data secure in our database with appropriate security mechanisms in place. '
      + 'We may share your personal data with other organizations where it is necessary for the purpose for '
      + 'which you have given us the data or as described in this notice. For example, we may pass data to '
      + 'other organizations, known as Data Processors, to provide specific services to us. A contract is '
      + 'always in place with a Data Processor, and they are not allowed to do anything with your data '
      + 'other than that which we have requested. In these cases, we never lose legal control of your data.',
    description: 'Protecting your data desc',
  },
  rightsTitle: {
    id: 'portal.views.privacyPolicy.rights.title',
    defaultMessage: 'What are your data protection rights?',
    description: 'What are your data protection rights section title',
  },
  rightsDescription: {
    id: 'portal.views.privacyPolicy.rights.description',
    defaultMessage: 'Legatum would like to make sure you are fully aware of your data protection rights. '
      + 'Every user is entitled to the following:',
    description: 'Rights desc',
  },
  rightAccess: {
    id: 'portal.views.privacyPolicy.rights.rightAccess',
    defaultMessage: 'The right to access. You have the right to request copies of your personal data from us;',
    description: 'Right: access',
  },
  rightRectification: {
    id: 'portal.views.privacyPolicy.rights.rightRectification',
    defaultMessage: 'The right to rectification. You have the right to request that we correct any '
      + 'information you believe is inaccurate. You also have the right to request we complete '
      + 'information you believe is incomplete;',
    description: 'Right: rectification',
  },
  rightErasure: {
    id: 'portal.views.privacyPolicy.rights.rightErasure',
    defaultMessage: 'The right to erasure. You have the right to request that we erase '
      + 'your personal data, under certain conditions;',
    description: 'Right: erasure',
  },
  rightRestrict: {
    id: 'portal.views.privacyPolicy.rights.rightRestrict',
    defaultMessage: 'The right to restrict processing. You have the right to request that '
      + 'we restrict the processing of your personal data, under certain conditions;',
    description: 'Right: restrict processing',
  },
  rightObject: {
    id: 'portal.views.privacyPolicy.rights.rightObject',
    defaultMessage: 'The right to object to processing. You have the right to object to '
      + 'us processing your personal data, under certain conditions;',
    description: 'Right: object to processing',
  },
  rightPortability: {
    id: 'portal.views.privacyPolicy.rights.rightPortability',
    defaultMessage: 'The right to data portability. You have the right to request that '
      + 'we transfer the data that we have collected to another organization, '
      + 'or directly to you, under certain conditions.',
    description: 'Right: data portability',
  },
  retentionTitle: {
    id: 'portal.views.privacyPolicy.retention.title',
    defaultMessage: 'How long do we retain your data for?',
    description: 'How long do we retain your data for section title',
  },
  retentionDescription: {
    id: 'portal.views.privacyPolicy.retention.description',
    defaultMessage: 'Data shall be processed and stored for as long as required by the purpose '
      + 'it has been collected for. We may be allowed to retain data for a longer period whenever '
      + 'you have given consent to such processing, provided that such consent is not withdrawn. '
      + 'Furthermore, we may be obliged to retain data for a longer period, whenever required to do so, '
      + 'for the performance of a legal obligation or upon the order of a legal or regulatory authority. '
      + 'Once the retention period expires, your data shall be deleted. '
      + 'Therefore, the right to access, the right to erasure, the right to rectification and the right '
      + 'to data portability cannot be enforced after the retention period expires.',
    description: 'Retention desc',
  },
  otherWebsitesTitle: {
    id: 'portal.views.privacyPolicy.otherWebsites.title',
    defaultMessage: 'Privacy policies of other websites',
    description: 'Privacy policies of other websites section title',
  },
  otherWebsitesDescription: {
    id: 'portal.views.privacyPolicy.otherWebsites.description',
    defaultMessage: 'This website contains links to other websites. Our privacy policy applies only '
      + 'to our website, so if you click on a link to another website, you should read their privacy policy carefully.',
    description: 'Other websites desc',
  },
  changesTitle: {
    id: 'portal.views.privacyPolicy.changes.title',
    defaultMessage: 'Changes to our privacy policy',
    description: 'Changes to our privacy policy section title',
  },
  changesDescription: {
    id: 'portal.views.privacyPolicy.changes.description',
    defaultMessage: 'We keep our privacy policy under regular review and place any updates on this web page. '
      + 'This privacy policy was last updated on 30 September 2024.',
    description: 'Changes desc',
  },
  contactTitle: {
    id: 'portal.views.privacyPolicy.contactUs.title',
    defaultMessage: 'How to contact us',
    description: 'How to contact us section title',
  },
  contactDesciption: {
    id: 'portal.views.privacyPolicy.contactUs.description',
    defaultMessage: 'If you have any questions about Legatum’s privacy policy, the data we hold on you, '
      + 'or you would like to exercise one of your data protection rights, please do not hesitate to contact us.',
    description: 'Contact desc',
  },
  contactEmail: {
    id: 'portal.views.privacyPolicy.contactUs.contactEmailLabel',
    defaultMessage: 'Email us at: <link>support@leadingwithcharacter.com</link>',
    description: 'Contact email label',
  },
  contactPhone: {
    id: 'portal.views.privacyPolicy.contactUs.contactPhoneLabel',
    defaultMessage: 'Call us at: <link>+971 4 317 5800</link>',
    description: 'Contact phone label',
  },
  contactAddressLabel: {
    id: 'portal.views.privacyPolicy.contactUs.contactAddressLabel',
    defaultMessage: 'Or write to us: Leading with Character, Level 2, Legatum Plaza, DIFC, PO Box 506625, Dubai, UAE',
    description: 'Contact address label',
  },
});

export default messages;
